<template>
  <div v-if="ready" class="feature">
    <FeatureMeta :feature="featureStore.feature" />

    <div v-if="featureStore.images.length === 0">
      <FeatureInitSection include-uploader :feature="featureStore.feature" />
      <PageRotateImage />
    </div>

    <div v-else class="h-full">
      <LayoutDefault @finished="onFinished">
        <template #aside>
          <div class="flex flex-col space-y-6 mt-8">
            <div class="flex">
              <label for="rotateAngle" class="w-1/3 input-label">Rotate</label>
              <div class="w-2/3 flex flex-col space-y-2">
                <div
                  v-for="(angle, index) in [
                    ['-90° (left)', -90],
                    ['0° (normal)', 0],
                    ['90° (right)', 90],
                    ['180°', 180],
                  ]"
                  :key="index"
                >
                  <input
                    :id="`rotate_${index}`"
                    v-model="featureStore.options[slug].rotateAngle"
                    class="radio"
                    :value="angle[1]"
                    type="radio"
                  />
                  <label class="input-label" :for="`rotate_${index}`">{{ angle[0] }}</label>
                </div>
              </div>
            </div>

            <div class="flex">
              <label for="flip" class="w-1/3 input-label">Flip</label>
              <div class="w-2/3 flex flex-col space-y-2">
                <div>
                  <input
                    id="flip_none"
                    v-model="featureStore.options[slug].flipType"
                    class="radio"
                    :value="null"
                    type="radio"
                  />
                  <label class="input-label" for="flip_none">None</label>
                </div>
                <div>
                  <input
                    id="flip_horizontal"
                    v-model="featureStore.options[slug].flipType"
                    class="radio"
                    value="horizontal"
                    type="radio"
                  />
                  <label class="input-label" for="flip_horizontal">Horizontal</label>
                </div>
                <div>
                  <input
                    id="flip_vertical"
                    v-model="featureStore.options[slug].flipType"
                    class="radio"
                    value="vertical"
                    type="radio"
                  />
                  <label class="input-label" for="flip_vertical">Vertical</label>
                </div>
                <div>
                  <input
                    id="flip_both"
                    v-model="featureStore.options[slug].flipType"
                    class="radio"
                    value="both"
                    type="radio"
                  />
                  <label class="input-label" for="flip_both">Both</label>
                </div>
              </div>
            </div>
          </div>
        </template>
      </LayoutDefault>
    </div>
  </div>

  <div v-else class="feature-loader">
    <img src="@/images/system/loader.gif" alt="Loader" />
  </div>
</template>

<script setup lang="ts">
  import { useFeatureSetup } from '$/composables/useFeatureSetup'
  import PageRotateImage from '&/landing_pages/PageRotateImage.vue'
  import FeatureMeta from '&/FeatureMeta.vue'

  const { ready, router, featureStore, slug, LayoutDefault, FeatureInitSection } = useFeatureSetup()

  function onFinished() {
    router.push({ name: 'RotateImageResult' })
  }
</script>
